export default "__VITE_ASSET__Ci1Rq8nY__"